var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import * as React from "react";
import { observer } from "mobx-react";
import { Button, Input, Flex, Center, Box, Container, InputGroup, InputRightElement } from "@chakra-ui/react";
import { Greetings } from "./GreetingView";
import { StoreContext } from "../uistore/Rootstore";
import { FiArrowRight } from "@react-icons/all-files/fi/FiArrowRight";
import { AppColor } from "../const/AppDefaults";
import { ProgressBar } from "../UIComponents/ProgressBar";
import { AppState } from "@/share/AppState";
import { testIsMobile } from "@@/Util";
let LoginView = class LoginView extends React.Component {
    login() {
        const rstore = this.context;
        rstore.loginViewStore.loginDevice();
    }
    componentWillUnmount() {
        const rstore = this.context;
        rstore.loginViewStore.reset();
    }
    reset() {
        const rstore = this.context;
        rstore.confirmStore.setMessage("Are you sure you want to reset organisation?");
        rstore.confirmStore.setOpen(true);
        rstore.confirmStore.setOkCB(() => {
            rstore.authStore.wipe();
        });
    }
    forgotPassword() {
        const rstore = this.context;
        rstore.authStore.setAppState(AppState.ResetPassword);
    }
    render() {
        const rstore = this.context;
        const appDefaultColour = AppColor.Default;
        return (React.createElement(Center, null,
            React.createElement(Box, { mt: '5%', h: testIsMobile() ? (window.innerHeight - 100) + "px" : (window.innerHeight - 150) + "px", className: 'login-container', width: testIsMobile() ? window.innerWidth - 50 + "px" : '600px' },
                React.createElement(Greetings, null),
                React.createElement(Box, null,
                    rstore.loginViewStore.tryinglogin && React.createElement(Box, null,
                        React.createElement(ProgressBar, { state: rstore.loginViewStore.progressstate })),
                    !rstore.loginViewStore.tryinglogin && React.createElement(Box, null,
                        React.createElement(Container, null,
                            React.createElement(Center, null,
                                React.createElement(InputGroup, null,
                                    React.createElement(Input
                                    // style={{color:'#FFFFFF'}} 
                                    , { 
                                        // style={{color:'#FFFFFF'}} 
                                        focusBorderColor: AppColor.HeaderIconColor, variant: "outline", placeholder: "Password", type: rstore.loginViewStore.showpassword ? "text" : "password", value: rstore.loginViewStore.password, onChange: (e) => rstore.loginViewStore.setPassword(e.currentTarget.value) }),
                                    React.createElement(InputRightElement, { width: "4.5rem" },
                                        React.createElement(Button, { h: "1.75rem", size: "sm", onClick: () => rstore.loginViewStore.toggleShowPassword() }, rstore.loginViewStore.showpassword ? "Hide" : "Show"))))),
                        React.createElement(Flex, { mt: '15px', flexDirection: 'column', alignItems: 'center' },
                            React.createElement(Button, { disabled: rstore.loginViewStore.password ? false : true, onClick: () => this.login(), rightIcon: React.createElement(FiArrowRight, null), size: 'sm', colorScheme: 'lwcolor', variant: "solid" }, "Login"),
                            React.createElement(Button, { onClick: () => this.forgotPassword(), mt: '15px', size: 'sm', color: AppColor.LoginButtonIconColor, variant: 'link' }, "Forgotten Password?"),
                            React.createElement(Button, { mt: '15px', onClick: () => this.reset(), size: 'sm', color: AppColor.LoginButtonIconColor, variant: 'link' }, "Reset")))))));
    }
};
LoginView.contextType = StoreContext;
LoginView = __decorate([
    observer
], LoginView);
export { LoginView };
